import { post } from '../Services/http';
import {
  LANGUAGE_SELECTOR_SHOW_WINDOW,
  LANGUAGE_SELECTOR_RECEIVE,
} from '../constants';

let abortController;

export const toggleShowWindow = (forceClose = false) => (
  dispatch,
  getState
) => {
  if (forceClose) {
    dispatch(show(false));
  } else {
    dispatch(show(!getState().languageSelector.showWindow));
  }
};

export const getRegions = () => (dispatch, getState) => {
  abortController && abortController.abort();
  abortController = new AbortController();
  return post('/api/languageselector', {}, abortController)
    .then((response) => response.json())
    .then((result) => dispatch(receive(result)));
};

export const receive = (result) => ({
  type: LANGUAGE_SELECTOR_RECEIVE,
  payload: { result },
});

const show = (visible) => ({
  type: LANGUAGE_SELECTOR_SHOW_WINDOW,
  payload: { showWindow: visible },
});
